var chopstickTooltip = function() {
    $('[data-toggle="tooltip"]').tooltip();
};
